import { Platform } from 'react-native';

// Color Palette
export const colors = {
  // Primary Colors
  primary: '#3D7FE6',      // New blue color
  secondary: '#FFCB9C',    // New orange color
  accent: '#73EE69',       // New green color
  
  // Text Colors
  textPrimary: '#000000',  // Black text
  textSecondary: 'rgba(0, 0, 0, 0.8)',  // Semi-transparent black
  textMuted: 'rgba(0, 0, 0, 0.5)',      // More transparent black
  
  // Background Colors
  backgroundPrimary: '#E9E9E9',
  backgroundSecondary: 'rgba(0, 0, 0, 0.1)',
  backgroundTertiary: 'rgba(0, 0, 0, 0.05)',
  backgroundOverlay: '#E9E9E9',
  backgroundCard: '#3D7FE6',
  backgroundSquares: '#F7EEEE',
  
  // Button Colors
  buttonDefault: '#F7EEEE',
  buttonHover: '#434252',
  buttonTextDefault: '#4D4B55',
  buttonTextHover: '#CEB7E3',
  
  // Interactive States
  hover: '#434252',
  active: '#3D7FE6',
  disabled: 'rgba(0, 0, 0, 0.3)',
  
  // Utility Colors
  error: '#e74c3c',
  success: '#2ecc71',
  warning: '#f1c40f',
  info: '#3498db',
  border: 'rgba(0, 0, 0, 0.1)',
  
  // Special Colors
  letterGrade: '#4d7edd',
  venueName: '#FFCB9C',
  venueReportCardText: '#FFCB9C',
  purpleReplacement: '#434252',
  purpleButtonText: '#CEB7E3',
  visitWebsiteLink: '#73EE69',
  
  // Gradients and Overlays
  gradientStart: 'rgba(0, 0, 0, 0.8)',
  gradientEnd: 'rgba(0, 0, 0, 0.4)',
  modalOverlay: 'rgba(0, 0, 0, 0.5)',
};

// Typography
export const typography = {
  // Font Families
  primaryFont: 'VastagoGrotesk',
  fontFamily: {
    regular: 'VastagoGrotesk',
    medium: 'VastagoGrotesk',
    bold: 'VastagoGrotesk',
  },
  
  // Font Sizes
  size: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    xxl: 24,
    xxxl: 32,
  },
  
  heading1: {
    mobile: 32,
    tablet: 40,
    laptop: 48,
    desktop: 48,
  },
  heading2: {
    mobile: 28,
    tablet: 32,
    laptop: 36,
    desktop: 36,
  },
  heading3: {
    mobile: 24,
    tablet: 28,
    laptop: 32,
    desktop: 32,
  },
  body: {
    mobile: 14,
    tablet: 16,
    laptop: 16,
    desktop: 16,
  },
  caption: {
    mobile: 12,
    tablet: 14,
    laptop: 14,
    desktop: 14,
  },
  button: {
    mobile: 16,
    tablet: 18,
    laptop: 18,
    desktop: 18,
  },
};

// Shadows
export const shadows = {
  text: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  card: Platform.OS === 'web' ? '0px 4px 6px rgba(0,0,0,0.1)' : undefined,
  button: Platform.OS === 'web' ? '0px 2px 4px rgba(0,0,0,0.2)' : undefined,
  light: Platform.OS === 'web' ? '0px 2px 4px rgba(0,0,0,0.1)' : undefined,
  medium: Platform.OS === 'web' ? '0px 4px 6px rgba(0,0,0,0.15)' : undefined,
  heavy: Platform.OS === 'web' ? '0px 6px 8px rgba(0,0,0,0.2)' : undefined,
};

// Spacing
export const spacing = {
  xxs: 2,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
  xxxl: 64,
  header: 80
};

// Border Radius
export const borderRadius = {
  none: 0,
  xs: 2,
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  xxl: 24,
  round: 9999,
};

// Z-Index
export const zIndex = {
  base: 0,
  overlay: 10,
  modal: 20,
  tooltip: 30,
  toast: 40,
};

// Animations
export const animations = {
  hover: {
    scale: 1.05,
    transition: '0.2s ease-in-out',
  },
  fadeIn: {
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  buttonHover: {
    backgroundColor: colors.primary + 'dd',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
  },
}; 